import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './polyfill'
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18nextConf';

import { icons } from './assets/icons'

import { Provider } from 'react-redux'
import store from './redux/store'


import { Toaster } from 'react-hot-toast';



React.icons = icons

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  	<div>
    	<App/>
	     <Toaster />
     </div>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
